import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePopup } from '../../../contexts/PopupContext';
import { supabase } from '../../../lib/supabase';
import Loading from '../../layout/Loading';
import './SettingsPages.css';
import './AccountSettings.css';

function AccountSettings() {
  const { t } = useTranslation(['profile', 'shared']);
  const { openPopup } = usePopup();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUserData();
  }, []);

  const loadUserData = async () => {
    try {
      const { data: { user: authUser } } = await supabase.auth.getUser();
      
      if (authUser) {
        setUser(authUser);
      }
    } catch (error) {
      console.error('Error loading user data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeEmail = () => {
    openPopup('account-change-email', { currentEmail: user?.email }, 2);
  };

  const handleChangePassword = () => {
    openPopup('account-reset-password', { userEmail: user?.email }, 2);
  };

  const handleChangePhone = () => {
    openPopup('account-change-phone', { currentPhone: user?.phone }, 2);
  };

  const handleDeactivateAccount = () => {
    openPopup('account-deactivate', {}, 2);
  };

  const handleDeleteAccount = () => {
    openPopup('account-delete', {}, 2);
  };

  if (loading) {
    return (
      <div className="settings-page">
        <div className="settings-page-content">
          <Loading size="medium" />
        </div>
      </div>
    );
  }

  return (
    <div className="settings-page">
      <div className="settings-page-content">
        {/* Sekcja: Informacje konta */}
        <div className="account-settings-section">
          <h3 className="account-settings-section-title">
            {t('profile.settings.pages.account.accountInfo')}
          </h3>

          {/* Email */}
          <div className="account-settings-item">
            <div className="account-settings-item-label">
              {t('profile.settings.pages.account.email')}
            </div>
            <div className="account-settings-item-value">
              {user?.email || t('profile.settings.pages.account.notSet')}
            </div>
            <button
              className="account-settings-button"
              onClick={handleChangeEmail}
            >
              {t('profile.settings.pages.account.changeEmail')}
            </button>
          </div>

          {/* Hasło */}
          <div className="account-settings-item">
            <div className="account-settings-item-label">
              {t('profile.settings.pages.account.password')}
            </div>
            <div className="account-settings-item-value">
              ••••••••
            </div>
            <button
              className="account-settings-button"
              onClick={handleChangePassword}
            >
              {t('profile.settings.pages.account.changePassword')}
            </button>
          </div>

          {/* Numer telefonu */}
          <div className="account-settings-item">
            <div className="account-settings-item-label">
              {t('profile.settings.pages.account.phone')}
            </div>
            <div className="account-settings-item-value">
              {user?.phone || t('profile.settings.pages.account.notSet')}
            </div>
            <button
              className="account-settings-button"
              onClick={handleChangePhone}
            >
              {t('profile.settings.pages.account.changePhone')}
            </button>
          </div>
        </div>

        {/* Sekcja: Konto */}
        <div className="account-settings-section">
          <h3 className="account-settings-section-title">
            {t('profile.settings.pages.account.account')}
          </h3>

          {/* Deaktywacja konta */}
          <div className="account-settings-item">
            <div className="account-settings-item-info">
              <div className="account-settings-item-label">
                {t('profile.settings.pages.account.deactivateAccount')}
              </div>
              <div className="account-settings-item-description">
                {t('profile.settings.pages.account.deactivateDescription')}
              </div>
            </div>
            <button
              className="account-settings-button account-settings-button-warning"
              onClick={handleDeactivateAccount}
            >
              {t('profile.settings.pages.account.deactivateButton')}
            </button>
          </div>

          {/* Usuń konto */}
          <div className="account-settings-item">
            <div className="account-settings-item-info">
              <div className="account-settings-item-label">
                {t('profile.settings.pages.account.deleteAccount')}
              </div>
              <div className="account-settings-item-description">
                {t('profile.settings.pages.account.deleteDescription')}
              </div>
            </div>
            <button
              className="account-settings-button account-settings-button-danger"
              onClick={handleDeleteAccount}
            >
              {t('profile.settings.pages.account.deleteButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountSettings;
